import getAll from './GetAll';
import getOne from './GetOne';

export default {
  getAll,
  getOne,
};
